import React, { createContext, useContext, useState, ReactNode } from 'react';
import ServerErrorModal from '../components/ServerErrorModal';

interface ServerErrorContextType {
  showServerError: (message?: string, statusCode?: number) => void;
}

const ServerErrorContext = createContext<ServerErrorContextType | undefined>(undefined);

export const useServerError = () => {
  const context = useContext(ServerErrorContext);
  if (!context) {
    throw new Error('useServerError must be used within ServerErrorProvider');
  }
  return context;
};

interface ServerErrorProviderProps {
  children: ReactNode;
}

export const ServerErrorProvider: React.FC<ServerErrorProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [statusCode, setStatusCode] = useState<number | undefined>(undefined);

  const showServerError = (message?: string, code?: number) => {
    setErrorMessage(message || '');
    setStatusCode(code);
    setShowModal(true);
  };

  return (
    <ServerErrorContext.Provider value={{ showServerError }}>
      {children}
      <ServerErrorModal
        isOpen={showModal}
        onClose={() => {
          setShowModal(false);
          setErrorMessage('');
          setStatusCode(undefined);
        }}
        errorMessage={errorMessage}
        statusCode={statusCode}
      />
    </ServerErrorContext.Provider>
  );
};
